import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const REPLACE_COURSE_TYPE_MUTATION = gql`
  mutation replaceCourseType($idToReplace: ID!, $replacementId: ID!) {
    replaceCourseType(
      idToReplace: $idToReplace
      replacementId: $replacementId
    ) {
      results {
        ...CourseTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REPLACE_COURSE_TYPE_MUTATION
